<template>
  <div class="d-flex flex-column full-screen-active w-full flex-grow-1">
    <div v-if="sectionInfo.length > 0" class="d-flex flex-grow-1">
      <LeftBar v-if="!setQuestion"
               :key="componentKey"
               :basicData="basicData"
               :learningLanguage="learningLanguage.text"
               :lessonName="lessonName"
               :lessonsList="lessonsList"
               :lightModeActive="lightModeActive"
               :sectionInfo="sectionInfo"
               :sectionList="sectionList"
               :updateRate="updateRate"
               @columViewActive="columViewActive"
               @darkModeToLight="darkModeToLight"
               @serverStop="moveLessonView">
      </LeftBar>
      <leftBarChat v-else :lessonName="lessonName"
                   :lessonsList="lessonsList"
                   :lightModeActive="lightModeActive"
                   @columViewActive="columViewActive"
                   @darkModeToLight="darkModeToLight"
                   @setisQuestionAns="setisQuestionAns">
      </leftBarChat>
      <div class="flex-grow-1 position-relative">
        <Header :lessonName="lessonName"
                :lightModeActive="lightModeActive"
                :rate="rate"
                :time="sessionTime"
                @serverStop="kernelStop"
                @serverStart="kernelStart"
                @moveLearnViewClose="moveLearnViewClose">
        </Header>
        <input id="columnValue" :value="columnValue" type="hidden">
        <div class="d-flex slide-slider bg-contentPlayerBg">
          <div class="swiper-container gallery-top swiper-container-initialized swiper-container-horizontal">
            <main class="bg-documentGray">
              <div id="outer-wrapper">
                <div class="resizable-x">
                  <div class="split-view-left flex-basis766" >
                    <div class="position-relative split-view-left-wrapper">
                      <div class="t-color-white t-body3 t-line-h-22 h-full">
                        <Description :componentName="componentName" :learnPurposes="learnPurposes" :lessonData="lessonData" :lessonName="lessonName" :lightModeActive="lightModeActive" :materialObj="materialObj" :nextLesson="nextLesson" @updateProgress="updateProgress" :fetchLectureList="fetchLectureList">
                          <section v-show="isMaterial">
                            <div class="pdl-32 pdr-32 pdb-16">
                              <div class="t-body8 font-b mgt-32">{{$t('3186')}}</div>
                            </div>
                            <div v-for="(material, index) in materialObj" :key="index" :class="lightModeActive ? 'bg-blackHover b-whiteBorder':'bg-whiteHover b-whiteBorder'" class="d-flex align-items-center justify-content-between   pdt-15 pdb-15 b-radius4  mgl-32 mgr-32 mgb-16" @click="donwloadFile(material)" @keypress="donwloadFile(material)">
                              <div class="d-flex align-items-center flex-grow-1 mgl-24">
                                <button
                                    class="material-icons mdc-icon-button t-color-secondaryBtnText mgl--12 w-24 h-24 d-flex align-items-center justify-content-center">attach_file</button>
                                <span class="t-color-whiteHigh t-body1 font-rn pdl-20">{{ material.name }}</span>
                              </div>
                              <div>
                                <button
                                    class="material-icons mdc-icon-button t-color-iconInactiveText mgr-12  w-24 h-24 d-flex align-items-center justify-content-center" tabindex="0">download</button>
                              </div>
                            </div>

                          </section>
                        </Description>
                      </div>
                      <Footer v-if="lessonData" slot="footer" :lessonData="lessonData" :lightModeActive="lightModeActive" @darkModeToLight="darkModeToLight" @setisQuestionAns="setisQuestionAns"></Footer>
                    </div>
                  </div>
                  <div class="resizer-x">
                    <i class="material-icons t-color-whiteDisabled mgt-0 font20 cursor-pointer rotate-90">
                      drag_handle
                    </i>
                  </div>
                  <div :class="columnValue ? 'flex-row':'flex-column'" class="resizable-y" style="flex: 1 1">
                    <div class="split-view-right-top position-relative" style="flex: 55.55%;">
                      <div
                          class="code_editor_header d-flex justify-content-between align-items-center pdt-6 pdb-5 pdl-20 pdr-16 position-sticky">
                        <div class="t-subtile2 t-color-whiteHigh font-b flex-grow-1 d-flex align-items-center t-nowrap">
                          <i class="material-icons font-20 t-color-red mgr-20">folder</i>
                          <div v-show="!columnValue" class="t-subtile2 t-color-whiteHigh font-b flex-grow-1 d-flex align-items-center t-nowrap">
                          {{ csFileName }}
                          </div>
                        </div>

                        <div id="selectTheme"
                             class="mdc-select mdc-select--outlined mdc--select__custom--darkmode w-auto withborder">
                          <span class="mdc-select__dropdown-icon only-safari">
                              <svg class="mdc-select__dropdown-icon-graphic" focusable="false"
                                  viewBox="7 10 10 5">
                                <polygon class="mdc-select__dropdown-icon-inactive" fill-rule="evenodd"
                                        points="7 10 12 15 17 10" stroke="none">
                                </polygon>
                                <polygon class="mdc-select__dropdown-icon-active" fill-rule="evenodd"
                                        points="7 15 12 10 17 15" stroke="none">
                                </polygon>
                              </svg>
                            </span>
                             <select class=" font-r mdc-select__native-control t-color-whiteHigh mdc-select__anchor h-36 mdc-select-control-custom t-body6 pdt-8 seleduty hasActiveVal small1 border-r-tranparent" @change="setSelect($event)">
                            <option disabled selected> {{ theme2.name }} </option>
                            <option v-for="(item, index) in theme2List" :key="index" :value="item.value">
                              {{ item.name }}
                            </option>
                          </select>

                          <div class="mdc-notched-outline">
                            <div class="mdc-notched-outline__leading"></div>
                            <div class="mdc-notched-outline__notch">
                            </div>
                            <div class="mdc-notched-outline__trailing"></div>
                          </div>
                        </div>
                      </div>
                      <div slot="aceEditor" class="app_editor_wrapper scroll-y h-full scrollable-content" style="padding: unset">
                        <div id="aceEditorDiv" class="t-color-white t-body3 t-line-h-22">
                          <AceEditor ref="myEditor" v-model="content" :value="content" class="ace_editor" height="100%" lang="python"
                                     @init="initEditor"/>
                        </div>
                      </div>
                      <div :class="columnValue ? 'mgb-60' : 'position-sticky'" class="code_editor_controls flex-grow-1 d-flex justify-content-between align-items-center pdt-9 pdb-9 w-full bg-dark">
                        <button class="mdc-button mdc-button--leading" @click="downloadExecFile()">
                          <!-- <span class="mdc-button__ripple"></span> -->
                          <i aria-hidden="true" class="material-icons mdc-button__icon t-color-whiteDisabled font-24">download</i>
                          <!-- <span class="mdc-button__label t-color-whiteDisabled">다운로드</span> -->
                        </button>
                        <div class="d-flex pdr-20">
                          <button
		                          :class="[lightModeActive ? 'bg-contentPlayerBgLight' : 'bg-secondaryBtn', {'bg-disableBtn cursor-noDrop' : isServerStop}]"
                              class="mdc-button mdc-button--outlined  mdc-button--icon-leading min-w-auto pdl-12 pdr-12 mgr-8 t-nowrap"
		                          @click="sendMessage" @keypress.enter="sendMessage">
                            <span class="mdc-button__ripple"></span>
                            <span class="mdc-button__label t-color-contentText">{{ $t('3725') }}</span>
                          </button>
                          <button
                              class="mdc-button mdc-button--outlined videoHeaderBtn mdc-button--icon-leading min-w-auto pdl-12 pdr-12 t-nowrap"
                              @click="resetMessage" @keypress="resetMessage">
                            <span class="mdc-button__ripple"></span>
                            <span class="mdc-button__label t-color-whiteHigh">{{ $t('3726') }}</span>
                          </button>
                        </div>
                      </div>
                    </div>

                    <div :class="columnValue ? 'flex-row':'flex-column'" class="d-flex resizer-y">
                      <div :class="columnValue ? 'border-lr h-full resizer-y':'d-flex align-items-center justify-content-center pdt-1 pdb-1 w-full '" class="">
                        <i :class="columnValue ? 'rotate-90':' '" class="material-icons t-color-whiteDisabled mgt-0 font20 cursor-pointer">drag_handle</i>
                      </div>
                      <div class="divider-white divider-subtabs w-full"></div>
                    </div>
                    <div class="split-view-right-bottom" style="flex: 45.45%;">
                      <div id="resultContent" class="scroll-y h-full scrollable-content" >
                        <div class="code-wrapper">
                          <div :class="[lightModeActive ? ' t-color-bodyGrayB' : ' t-color-white', columnValue ? 'pdt-13 pdb-13 box-48' : ' pdt-14 pdb-13']" class="t-body1  pdl-20">{{ $t('3727' )}}</div>
                        </div>
                        <div class="divider-white divider-subtabs w-full"></div>
                        <div :class="lightModeActive ? ' t-color-whiteHigh' : ' t-color-white'"
                             class="t-body3 t-line-h-22 pda-16"
                             v-html="socketResult"
                             ref="socketResultContainer">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AceEditor from "vue2-ace-editor";
import {csStudyType} from "@/mixins/csStudyType";
import '@/css/computerScience.css';
import microLearnApi from "@/api/microLearnApi";
import Header from "./Header";
import Footer from "./Footer";
import LeftBar from "./LeftBar";
import leftBarChat from "./LeftBarChat";
import Description from "./Description";
import {MDCRipple} from "@material/ripple";
import {MDCSelect} from "@material/select";
import {MDCDialog} from '@material/dialog'
import {fileMixin} from "@/mixins/file";
import { studyConst } from "@/utils/constants/StudyConstants"

export default {
  name: "Total",

  data() {
    return {
      basicData: null,
      columnValue: false,
      lightModeActive: localStorage.getItem("themeMode") === "light",

      memberId: Number,
      objective:{},
      learnPurposes: {},
      componentName: null,
      subtitles: null,
      slideFiles: [],
      lessonData: null,
      lessonName: "",
      lessonsList: [],
      nextLesson: null,
      nextLessonName: "",
      currentProgressionId: "",
      updateRate: 0,
      rate: 0,
      last: 0,
      recent: 0,
      time: 0,
      content: "",
      isChat: false,
      sectionInfo: {},
      sectionList: [],
      personalInfo: {},
      materialObj: null,
      csFileName: "",
      courseName: "",
	    sessionTime: 0,
	    sessionTimeInterval: null,
	    sessionInterval: null,
	    isWorking: true,
      componentKey: 0,
      sequenceProgressionRate: 0,
      isServerStop: false,
	    kernelId: ""
    }
  },

  mixins: [csStudyType, fileMixin],

  components: {
    AceEditor,
    Header,
    Footer,
    LeftBar,
    leftBarChat,
    Description
  },
	
	watch: {
		sessionTime: function (val, oldVal) {
			if (val === 10) {
				const confirmOptions = {autoClose:true, time: 10000}
				this.$confirm({
					content: `${this.$t('3879')}<br/>${this.$t('3880')}`,
					accept:  this.$t('3881'),
					cancel:  this.$t('3882'),
				}, confirmOptions).then(() => {
					this.kernelStart();
				}).catch(() => {})
			} else if (val === 0) {
				this.kernelStop();
			}
		}
	},

  computed: {
    setQuestion() {
      return this.isChat;
    },

    isMaterial() {
      return this.materialObj && this.materialObj.length > 0;
    },

    theme2() {
      return this.theme2List.find(theme => {
        return theme.value === this.themePath
      });
    },
  },

  mounted() {
	  this.fetchLearnObjective();
    this.fetchData();
	  this.fetchLectureList();
    this.fetchLessonContents();
  },

  methods : {
    updateProgress(rate) {
      this.rate = rate;
      this.updateRate = this.rate;
      if(this.updateRate >= this.sequenceProgressionRate) {
        this.fetchLectureList();
      }
    },

    columViewActive(column) {
      this.columnValue = column;
    },

    fetchData() {
      let responseData = null;
      let params = this.setParams();

      microLearnApi
          .learnViewBasic(params)
          .then(response => {
            this.basicData = response.data.data;
            let learningPolicy = this.basicData.learningPolicy;
            if(learningPolicy.lessonSequence) {
              this.sequenceProgressionRate = learningPolicy.lessonMoveMinRate;
            }
          })
          .catch(err => {
            responseData = err.response.data.meta;
            this.$error({ content: responseData.errMsg }).then(() => {});
          });
    },

    // 학습 목록 API 호출(get lesson list)
    fetchLectureList() {
      let params = this.setParams();

        microLearnApi.learnViewCourses(params).then((response) => {
          // 과정의 차시 정보만 병합
          // Merging only lesson data from the course
          this.sectionInfo = response.data.data;
          this.sectionList = [];
          _.each(this.sectionInfo, course => {
            this.courseName = course.name;
            this.sectionList = [...this.sectionList, ...course.sections.map(section => ({...section, courseName: this.courseName}))];
            this.componentKey += 1;
            _.each(course.sections, section => {
              this.lessonsList = this.lessonsList.concat(section.lessons);
              section.courseName = this.courseName;
              _.each(this.lessonsList, (lesson) => {
                if (lesson.id === this.$route.params.lessonId) {
                  return this.materialObj = lesson.learningMaterials;
                }
              });
            });
          });
          // 다음 차시명 설정(set next lesson)
          let currentLessonIndex = _.findIndex(this.lessonsList, lesson => {
            return lesson.progressionId === this.currentProgressionId;
          });
          let nextLessonIndex =
              this.lessonsList.length > 1 &&
              this.lessonsList.length > currentLessonIndex
                  ? (currentLessonIndex += 1)
                  : -1;
          if (nextLessonIndex) {
            this.nextLesson = this.lessonsList[nextLessonIndex];
            if (nextLessonIndex === -1) {
              this.nextLessonName = this.$t("1999");
            } else {
              if (typeof this.lessonsList[nextLessonIndex] != "undefined") {
                this.nextLessonName = this.lessonsList[nextLessonIndex].name;
              } else {
                this.nextLessonName = this.$t("1999");
              }
            }
          }
        })
      if (typeof this.$route.query.questionChatType != "undefined") {
        this.setisQuestionAns();
      }
    },

    fetchLessonContents() {
      let params = this.setParams();
      microLearnApi.learnLessonContents(params).then(response => {

        this.lessonData = response.data.data;
        this.componentName = this.lessonData.type.value;
        this.lessonName = this.lessonData.lessonName;
        this.rate = this.lessonData.rate;
        this.last = this.lessonData.last;
        this.recent = this.lessonData.recent;
        this.currentProgressionId = this.lessonData.progressionId;
        this.learningLanguage = this.lessonData.learningLanguage;
        this.subtitles = this.lessonData.video ? this.lessonData.video.subtitles : null;
        this.slideFiles = this.lessonData.slide
            ? this.lessonData.slide.files
            : null;
        this.pdfFileUrl = this.lessonData.pdf ? this.lessonData.pdf.file : null;
        this.linkUrl = this.lessonData.html
            ? this.lessonData.html.files.filter(url => !url.includes("__MACOSX"))
            : null;
        this.updateRate = this.rate;
        if (this.learningLanguage !== undefined) {
          this.createComputerScienceAccount(this.memberId).then(() => {
          });
        } else {
          if (this.lessonData.contentsType.value === "COMPUTER_SCIENCE") {
            let errMsg = this.$t(`system.err.1000`);
            this.$error({ content: errMsg }).then(() => {
              this.$router.push({
                name: "MicroDegreeView",
                params: this.$route.params,
                query: this.$route.query
              });
            });
          }
        }
      });
    },

    fetchLearnObjective() {
      microLearnApi.openNextLearning(this.$route.params.learnId).then(() => {
        microLearnApi
          .learnLessonObjective({
            learnId: this.$route.params.learnId,
            progressionId: this.$route.params.progressionId
          })
          .then(response => {
            this.objective = response.data.data;
            this.learnPurposes = this.getLearnPurposes(this.objective.learnInfo);
          });
      }).catch((err) => {
        console.log("ERROR OPEN NEXT LEARNING API : ", err)
      });
    },

    async createComputerScienceAccount(idx) {
      await microLearnApi.createComputerScienceUser(idx).then(() => {
        /**
         * TODO: 임시로 계정 생성호출 API 주석처리 해두고 있습니다.
         */
        this.computerScienceProcess(
            this.$route.params.learnId,
            this.$route.params.progressionId
        );
      });
    },

    async computerScienceProcess(learnerId, lessonId) {
      //jupyterhub contents 생성
      const registerContentsParams = {
        learnerId: learnerId,
        lessonId: lessonId
      };

      const contentsResponse = await microLearnApi.registerComputerScienceContents(registerContentsParams);
      this.csFileName = contentsResponse.name;
	    this.kernelStart();
    },

    async getSession() {
      const params = {
        sessionId: this.sessionId
      };
      return await microLearnApi.getComputerScienceSession(params)
    },

	  startSessionTime () {
		  this.stopSessionTime();
			this.sessionTime = studyConst.SESSION_DEFAULT_SECONDS;
		  this.sessionTimeInterval = setInterval(()=> {
			  --this.sessionTime;
		  }, 1000);
	  },
	  
	  stopSessionTime() {
		  clearInterval(this.sessionTimeInterval);
			this.sessionTime = 0;
	  },

	  // serverStart() {
		//   this.$showLoading();
		//   this.computerScienceProcess(
		// 		  this.$route.params.learnId,
		// 		  this.$route.params.progressionId
		//   ).then(() => {
    //     this.isServerStop = false;
		// 		this.$hideLoading();
		// 	  this.startSessionTime();
		//   }).catch((e) => {
		// 	  this.$hideLoading();
		//
		//   });
	  // },
	  
	  kernelStart() {
		  this.$showLoading();
		  const params = {
			  sessionId: this.sessionId,
			  kernelId: this.kernelId,
			  memberId: this.memberId
		  }
			microLearnApi.computerScienceKernelStart(params)
		  .then((response) => {
				this.kernelId = response.data.data.id;
			  this.$hideLoading();
			  this.startSessionTime();
			  this.isServerStop = false;
				//커널이 시작 할때마다 소켓을 다시 연결해준다.
			  this.socketConnection(this.csFileName, this.learningLanguage.value);
		  }).catch((e) => {
				this.$hideLoading();
				console.log("Kernel Start Error" + e);
			});
	  },
	  
	  async socketConnection(fileName, language) {
		  //jupyterhub 소켓통신 url 조회
		  const webSocketUrlParams = {
			  name: fileName,
			  learningLanguage: language
		  };
		  const socketResponse = await microLearnApi.getComputerScienceWebSocketUrl(webSocketUrlParams);
		  this.socketUrl = socketResponse.socketUrl;
		  this.authorization = socketResponse.authorization;
		  this.sessionId = socketResponse.sessionId;
		  this.kernelId = socketResponse.kernelId;
		  
			if (this.socket !== null && this.socket !== undefined && this.socket.readyState === 1) {
				return;
			}
		  //소켓 연결
		  this.socket = new WebSocket(this.socketUrl + `&token=${this.authorization}`);
		  this.socket.onmessage = event => this.onMessage(event);
		  this.socket.onopen = event => this.onOpen(event);
		  this.socket.onclose = event => this.onClose(event);
		  this.socket.onError = event => this.onError(event);
	  },
	
	  async kernelStop() {
			if (this.isServerStop) {
				return;
			}
		  this.$showLoading();
			try {
				const params = {
					sessionId: this.sessionId,
					kernelId: this.kernelId,
					memberId: this.memberId
				}
				await microLearnApi.computerScienceKernelDelete(params);
				this.$hideLoading();
				this.stopSessionTime();
				this.isServerStop = true;
				this.socket.close();
			} catch (e) {
				this.$hideLoading();
				console.log("Kernel Delete Error" + e);
			}
	  },

    // serverStop(obj) {
    //   this.$showLoading();
    //   this.isWorking = false;
	  //
    //   if(this.isServerStop) {
    //     this.$hideLoading();
    //     this.$_routeToLessonView(obj);
    //     return;
    //   }
	  //
    //   microLearnApi.computerScienceServerStop()
    //       .then((response) => {
    //         this.$hideLoading();
    //         this.sessionTime = 15;
    //         if (response.data.data === true) {
    //           this.isServerStop = true;
    //         }
    //         clearInterval(this.sessionTimeInterval);
    //         this.$_routeToLessonView(obj);
    //       })
    //       .catch((error) => {
    //         this.$hideLoading();
    //         console.error(error);
    //         this.$_routeToLessonView(obj);
    //       });
    // },
	  //
    // $_routeToLessonView(obj) {
    //   if(!obj) return;
    //     this.$router.push({
    //       name: 'MicroDegreeLessonView',
    //       params: {
    //         learnId: parseInt(this.$route.params.learnId),
    //         lessonId: obj.id,
    //         progressionId: obj.progressionId
    //       },
    //       query: this.$route.query
    //     });
    // },
	  //
	  // updateContents(learnerId, lessonId) {
		//   const registerContentsParams = {
		// 	  learnerId: learnerId,
		// 	  lessonId: lessonId,
		// 	  content: this.content
		//   };
		// 	microLearnApi.computerScienceUpdateContent(registerContentsParams).then(()=> {
		// 	});
	  // },

    setSelect(event) {
      this.setEditorTheme(event)
    },
	  
	  async moveLessonView(lesson) {
		  await this.kernelStop();
		  this.$router.push({
			  name: 'MicroDegreeLessonView',
			  params: {
				  learnId: parseInt(this.$route.params.learnId),
				  lessonId: lesson.id,
				  progressionId: lesson.progressionId
			  },
			  query: this.$route.query
		  });
	  },

    async moveLearnViewClose() {
      await this.kernelStop();
      this.$router.push({
	      name: "MicroDegreeView",
	      params: this.$route.params.learnId,
	      query: {status: this.$route.query.status},
      });
    },

    // API 파라미터 설정(set parameter)
    setParams() {
      let params = {
        total: this.slideFiles && this.slideFiles.length,
        current: this.currentSlide,
        learnId: this.$route.params.learnId,
        progressionId: this.$route.params.progressionId
      };
      return params;
    },
  },

	beforeDestroy() {
		clearInterval(this.sessionTimeInterval);
		// this.serverStop();
	},
}
</script>

<style scoped>
#wrap-slide-contents {
  overflow: hidden;
  position: relative;
  top: -200px;
  right: -150px;
  width: 50%;
  height: 50%;
}

#resultContent >>> .input-box {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  border: solid 1px #5a6a7d;
  background-color: #fff;
}

#resultContent >>> .input-box:focus {
  border: solid 1px var(--Textfeilderror);
}
</style>
